<template>
  <v-app>
    <div>
      <NavDrawer :windowWidth="windowWidth" />
      <MenuDrawer :windowWidth="windowWidth" />
      <PageLove :windowWidth="windowWidth" />
    </div>
    <NvBar v-if="$route.name !== 'checkOut' && windowWidth > 990" />
    <FixedNav v-if="$route.name !== 'checkOut' && windowWidth > 990" />
    <ResponsePage v-show="windowWidth <= 990 && $route.name !== 'check_out'" />
    <router-view />
    <AppFooter v-if="$route.name !== 'checkOut'" />
  </v-app>
</template>

<script setup>
import { ref, onMounted } from "vue";
import MenuDrawer from "@/components/golbal/MenuDrawer.vue";
import NavDrawer from "@/components/golbal/NavDrawer.vue";
import PageLove from "@/components/golbal/PageLove.vue";
import NvBar from "@/components/golbal/NvBar.vue";
import AppFooter from "./components/golbal/AppFooter.vue";
import FixedNav from "./components/golbal/FixedNav.vue";
import ResponsePage from "@/components/golbal/ResponsePage.vue";

const windowWidth = ref(0);
onMounted(() => {
  windowWidth.value = window.innerWidth;
  window.onresize = () => {
    windowWidth.value = window.innerWidth;
    console.log(windowWidth.value);
  };
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
